export default "/images/layers.svg?545d0f51e74c7433cf988b0cfa78622e";